import React, { Component } from 'react';
import __ from 'lodash';
import parse from 'html-react-parser';

class TblSosEkonomi extends Component {
    constructor(props) {
        super(props);
        this.state = {             
            data: [],
        }
    }

    componentDidMount() {
        if(!__.isEmpty(this.props.data)) {              
            this.setState({ data: this.props.data})
        }
    }

    renderRow() {
        let result = '';
        this.state.data.map(parent => {            
            result += '<tr><td rowspan="'+parent.kategori.length+'">'+parent.soal+'</td>';
            const elemt = parent.kategori[0];
            result += '<td>'+elemt.namaKategori+'</td><td style="text-align: center">'+elemt.jumlah+'</td><td style="text-align: center">'+elemt.prosen+'</td></tr>';            
            parent.kategori.map((child,j) => {
              if(j !== 0) 
                result += '<tr><td>'+child.namaKategori+'</td><td style="text-align: center">'+child.jumlah+'</td><td style="text-align: center">'+child.prosen+'</td></tr>';                
            })            
        })
        return result;
    }

    render() {
        return(
            <table className="table-asm" width="100%" border="1">
                <thead>
                    <tr>
                        <th className="text-center" width="30%">Aspek</th>
                        <th className="text-center">Kriteria</th>
                        <th className="text-center" width="5%">Jumlah Siswa</th>
                        <th className="text-center" width="5%">%</th>
                    </tr>
                </thead>
                <tbody>
                    {parse(this.renderRow())}
                    {/* <tr>                    
                        <td rowSpan="4">Pend</td>
                        <td>asdasd</td><td>1</td><td>1</td> 
                    </tr>
                    <tr>                    
                        <td>asdasd</td><td>1</td><td>1</td>
                    </tr>
                    <tr>                    
                        <td>asdasd</td><td>1</td><td>1</td>
                    </tr>
                    <tr>                    
                        <td>asdasd</td><td>1</td><td>1</td>
                    </tr>

                    <tr>
                        <td rowSpan="3">Pend 2</td>
                        <td>asdasd</td><td>1</td><td>1</td> 
                    </tr>
                    <tr>                    
                        <td>asdasd</td><td>1</td><td>1</td>
                    </tr>
                    <tr>                    
                        <td>asdasd</td><td>1</td><td>1</td>
                    </tr> */}
                    
                </tbody>
            </table>
        )
    }

}

export default TblSosEkonomi;